function getCookie(name) {
    const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}

function setStorageItem(key, value) {
    try {
        return window.localStorage.setItem(key, value)
    } catch (e) {
        console.log(e)
    }
}

function getStorageItem(key, value) {
    try {
        return window.localStorage.getItem(key)
    } catch (e) {
        console.log(e)
    }
}

(function() {
    const searchParams = new URLSearchParams(window.location.search);

    if(!searchParams.get('ndl') && searchParams.get('utm_source') && !getCookie('target_url_write')) {
        setStorageItem('target_url', window.location.href);
        document.cookie = 'target_url_write = 1; path=/; domain=' + location.hostname + '; max-age=60' + '; Secure; SameSite=Strict';
    }

    if (!searchParams.get('utm_source') && !getStorageItem('target_url')) {
        if (document.referrer.indexOf('google') >= 0) {
            setStorageItem('target_url', window.location.origin + '/?utm_source=google&utm_medium=organic&utm_campaign=organic');
        } else if (document.referrer == '' || document.referrer.indexOf(window.location.hostname) >= 0) {
            setStorageItem('target_url', window.location.origin + '/?utm_source=direct&utm_medium=none&utm_campaign=direct');
        } else {
            let referrer = new URL(document.referrer).hostname;

            if (referrer.substring(0, 4) === 'www.') {
                referrer = referrer.substring(4);
            }

            setStorageItem('target_url', window.location.origin + '/?utm_source=referral&utm_medium=referral&utm_campaign=' + referrer);
        }

        document.cookie = 'target_url_write = 1; path=/; domain=' + location.hostname + '; max-age=60' + '; Secure; SameSite=Strict';
    }
})();
